module.exports = __webpack_public_path__ + "static/logo-footer-308e2bed0554edc151ab18b7588233eb.png";